module.exports = __webpack_public_path__ + "static/technical-graphic-9142b7155a51b06a91ce6aa430557a88.svg";